import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header className="bg-white shadow">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <Link to="/" className="text-xl font-bold text-primary-600">베트남국제결혼</Link>
          </div>
          
          {/* 모바일 메뉴 버튼 */}
          <div className="md:hidden">
            <button 
              type="button" 
              className="text-gray-500 hover:text-gray-600 focus:outline-none"
              onClick={toggleMenu}
            >
              <svg className="h-6 w-6" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                {isMenuOpen ? (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                ) : (
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                )}
              </svg>
            </button>
          </div>
          
          {/* 데스크탑 메뉴 */}
          <div className="hidden md:flex md:items-center md:space-x-6">
            <Link to="/" className="text-gray-600 hover:text-primary-600 px-2 py-1 rounded-md text-sm font-medium">홈</Link>
            <Link to="/match" className="text-gray-600 hover:text-primary-600 px-2 py-1 rounded-md text-sm font-medium">매칭 서비스</Link>
            <Link to="/success-stories" className="text-gray-600 hover:text-primary-600 px-2 py-1 rounded-md text-sm font-medium">성공 사례</Link>
            <Link to="/contact" className="text-gray-600 hover:text-primary-600 px-2 py-1 rounded-md text-sm font-medium">문의하기</Link>
            <Link 
              to="/contact" 
              className="bg-primary-600 text-white px-4 py-2 rounded-md text-sm font-medium hover:bg-primary-700"
            >
              무료 상담
            </Link>
          </div>
        </div>
        
        {/* 모바일 메뉴 */}
        {isMenuOpen && (
          <div className="md:hidden py-3">
            <div className="flex flex-col space-y-2">
              <Link 
                to="/" 
                className="text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                홈
              </Link>
              <Link 
                to="/match" 
                className="text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                매칭 서비스
              </Link>
              <Link 
                to="/success-stories" 
                className="text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                성공 사례
              </Link>
              <Link 
                to="/contact" 
                className="text-gray-600 hover:text-primary-600 px-3 py-2 rounded-md text-base font-medium"
                onClick={() => setIsMenuOpen(false)}
              >
                문의하기
              </Link>
              <Link 
                to="/contact" 
                className="bg-primary-600 text-white px-3 py-2 rounded-md text-base font-medium hover:bg-primary-700"
                onClick={() => setIsMenuOpen(false)}
              >
                무료 상담
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header; 